import styled from "styled-components";
import { Link } from "gatsby";

import Arrow from "../../../assets/svg/icons/ArrowNE.svg";

import {
  COLORS
} from "../../../theme/style-constants";


export const LinkContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin: 1rem 0;
  color: ${ COLORS.text.black };
  transition: all 0.3s ease-in-out;

  h3 {
    margin: 0;
  }
`;

export const LinkArrow = styled(Arrow)`
  height: 0.8rem;
  width: 0.8rem;
  transition: all 0.3s ease-in-out;
`;

export const StyledInternalLink = styled(Link)`
  display: inline-block;
  width: 100%;
  color: ${ props => ( props.darkBackground === true ? COLORS.text.light : COLORS.text.dark ) };
  text-decoration: none;

  &:hover {
    ${ LinkContainer } {
      color: ${ COLORS.text.orange };
    }

    ${ LinkArrow } {
      stroke: ${ COLORS.text.orange };
    }
  }

  &:visited {
    color: ${ props => ( props.darkBackground === true ? COLORS.text.light : COLORS.text.dark ) };
  }
`;

export const StyledExternalLink = styled.a`
  display: inline-block;
  width: 100%;
  color: ${ props => ( props.darkBackground === true ? COLORS.text.light : COLORS.text.dark ) };
  text-decoration: none;

  &:hover {
    ${ LinkContainer } {
      color: ${ COLORS.text.orange };
    }

    ${ LinkArrow } {
      stroke: ${ COLORS.text.orange };
    }
  }

  &:visited {
    color: ${ props => ( props.darkBackground === true ? COLORS.text.light : COLORS.text.dark ) };
  }
`;
